/** @format */

import { Grid } from '@material-ui/core';
import { format } from 'date-fns';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation, useParams, Link } from 'react-router-dom';
import { Redirect } from 'react-router';
import { Button } from 'src/components';
import Breadcrumb from 'src/components/Breadcrumb';
import { KnowledgeBaseItem } from 'src/components/knowledegeBase/item';
import { KnowledgeBaseSearch } from 'src/components/knowledegeBase/search';
import LoadingScreen from 'src/components/LoadingScreen';
import Page from 'src/components/Page';
import SelectComponent from 'src/components/select';
import useQuery from 'src/hooks/useQuery';
import { getKnowledgeBase, getKnowledgeBaseArticles } from 'src/slices/knowledgeBase';
import { useDispatch, useSelector } from 'src/store';

export default function KnowledgeBase() {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const { kb } = useParams();
  const query = useQuery().get('query');
  const { t } = useTranslation();
  const { knowledgeBase, knowledgeBaseLoading, knowledgeBaseArticles, knowledgeBaseArticlesLoading, error } =
    useSelector(state => state.knowledgeBase);
  const [category, setCategory] = useState(0);
  const [sort, setSort] = useState('cerated_desc');

  const storage = useMemo(() => window.localStorage, []);
  const lang = useMemo(() => storage.i18nextLng || 'en', []);

  useEffect(() => {
    dispatch(getKnowledgeBase(lang, kb));
  }, []);

  useEffect(() => {
    dispatch(
      getKnowledgeBaseArticles(lang, {
        kb: kb || 0,
        categories: category ? [category] : null,
        sort,
        query: query || ''
      })
    );
  }, [category, sort, query]);

  const pageTitle = knowledgeBase?.title || '';

  if (error || !kb) return <Redirect to="/404" />;
  if (knowledgeBaseLoading) return <LoadingScreen />;
  return (
    <Page className={`knowledge-base`} title={pageTitle}>
      <Breadcrumb data={[{ title: pageTitle }]} />
      <Grid className="knowledge-base-container">
        <Grid className="knowledge-base-title-box">
          <h1 className="knowledge-base-title">{pageTitle}</h1>
          <KnowledgeBaseSearch kb={kb} />
        </Grid>
        <Grid className="knowledge-base-text" dangerouslySetInnerHTML={{ __html: knowledgeBase?.body }} />
        <Grid className="knowledge-base-categories-sort">
          <h3>{t('knowledgeBase.categories')}</h3>
          <Grid className="knowledge-base-categories-sort-flex">
            <ul className="knowledge-base-categories">
              <li>
                <button className={category === 0 ? `active` : ''} onClick={() => setCategory(0)}>
                  {t('knowledgeBase.all')}
                </button>
              </li>
              {knowledgeBase?.categories?.map(cat => (
                <li key={cat.id}>
                  <button className={category === cat.id ? `active` : ''} onClick={() => setCategory(cat.id)}>
                    {cat.name}
                  </button>
                </li>
              ))}
            </ul>
            <Grid className="knowledge-base-sort">
              <SelectComponent
                label={t('knowledgeBase.sortBy')}
                options={[
                  { value: 'cerated_desc', name: t('knowledgeBase.newestDesc') },
                  { value: 'cerated_asc', name: t('knowledgeBase.newestAsc') },
                  { value: 'title_asc', name: t('knowledgeBase.alphabeticalAsc') },
                  { value: 'title_desc', name: t('knowledgeBase.alphabeticalDesc') }
                ]}
                onChange={e => e.target.value && setSort(e.target.value)}
                value={sort}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid className="knowledge_base-widget--list knowledge-base-list">
          {knowledgeBaseArticlesLoading ? (
            <LoadingScreen />
          ) : knowledgeBaseArticles?.length > 0 ? (
            knowledgeBaseArticles.map(item => <KnowledgeBaseItem item={item} kb={kb} key={item.nid} />)
          ) : (
            <p className="knowledge_base-widget--list-empty">{t('knowledgeBase.noResults')}</p>
          )}
        </Grid>
        <Button onClick={() => history.push(`/dashboard`)} borderOnly back label={t('knowledgeBase.backToHome')} />
      </Grid>
    </Page>
  );
}
